// 打印入口：个人费用报销检验回执单（A4 纵向）
// 打印对话框关闭后，按 IsDG 连续打印费用报销单（对公/个人）
import { printHtml } from "../htmlPrint";
import { buildReceiptHtml } from "./printTemplates";
import { receipt } from "../printConfig";
import printmb2 from "../mb/2";
import printmb3 from "../mb/3";

// Main: { entry1: [回执单数据...], entry2: 报销单数据 }
export default function(Main) {
  printHtml(buildReceiptHtml(Main.entry1), {
    ...receipt,
    title: "个人费用报销检验回执单",
    onAfterPrint: () => {
      if (!Main.entry2) return;
      if (Main.entry2.IsDG) printmb3(Main.entry2); // 对公
      else printmb2(Main.entry2); // 个人
    },
  });
}
